import { useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

const STATS_API = 'translation-keys/stats';
const OVERVIEW_API = 'translation-keys/stats/overview';

/**
 * Fetches aggregated stats from GET /translation-keys/stats
 * Returns: { totalKeys, translated, notTranslated, sameAsSource, byApp[], byTranslator[] }
 *
 * @param {object} params
 * @param {string} params.categoryName
 * @param {string} params.localeValue
 * @param {boolean} params.enabled
 */
export function useTranslationStats({ categoryName, localeValue, enabled = true } = {}) {
  const ky = useOkapiKy();

  const searchParams = {};
  if (categoryName) searchParams.categoryName = categoryName;
  if (localeValue)  searchParams.localeValue  = localeValue;

  return useQuery(
    [STATS_API, categoryName, localeValue],
    () => ky.get(STATS_API, { searchParams }).json(),
    {
      enabled: enabled && !!categoryName && !!localeValue,
      staleTime: 30_000,
    },
  );
}

/**
 * Fetches full dashboard overview from GET /translation-keys/stats/overview
 * Returns: { totalKeys, byLocale[], byCategory[], byTranslator[], recentActivity[], alerts[] }
 *
 * @param {boolean} enabled
 */
export function useTranslationOverview({ enabled = true } = {}) {
  const ky = useOkapiKy();

  return useQuery(
    [OVERVIEW_API],
    () => ky.get(OVERVIEW_API).json(),
    {
      enabled,
      staleTime: 60_000,
    },
  );
}
